<script setup>
import { computed } from "vue";

const props = defineProps({
	address: Object,
	query: String
});

const q = computed(() => {
	if (props.address) {
		return encodeURIComponent(
			["addr", "addr2", "zip", "city", "county", "country_id"]
				.filter((key) => props.address[key])
				.map((key) => props.address[key])
				.join(", ")
		);
	}
	else if (props.query)
		return encodeURIComponent(props.query);

	return null;
});
</script>

<template>
	<UiIframe :src="`https://www.google.com/maps/embed/v1/place?q=${q}&key=AIzaSyBxdubtPM7WrkQai8I9PBiIi2po3h0aEb8`"/>
</template>
